import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import { portfolioHeaderTranslationsDe, portfolioHeaderTranslationsEn, portfolioHeaderTranslationsEs, portfolioHeaderTranslationsFr, portfolioHeaderTranslationsIt, portfolioHeaderTranslationsNl } from '../portfolio-header/index.js';
import { portfolioCreateTranslationsDe, portfolioCreateTranslationsEn, portfolioCreateTranslationsEs, portfolioCreateTranslationsFr, portfolioCreateTranslationsIt, portfolioCreateTranslationsNl } from '../portfolio-create/index.js';
import { portfolioDeleteTranslationsDe, portfolioDeleteTranslationsEn, portfolioDeleteTranslationsEs, portfolioDeleteTranslationsFr, portfolioDeleteTranslationsIt, portfolioDeleteTranslationsNl } from '../portfolio-delete/index.js';
import { portfolioEditTranslationsDe, portfolioEditTranslationsEn, portfolioEditTranslationsEs, portfolioEditTranslationsFr, portfolioEditTranslationsIt, portfolioEditTranslationsNl } from '../portfolio-edit/index.js';
import { portfolioPositionsListTranslationsDe, portfolioPositionsListTranslationsEn, portfolioPositionsListTranslationsEs, portfolioPositionsListTranslationsFr, portfolioPositionsListTranslationsIt, portfolioPositionsListTranslationsNl } from '../portfolio-positions-list/index.js';
import { portfolioTransactionsListTranslationsDe, portfolioTransactionsListTranslationsEn, portfolioTransactionsListTranslationsEs, portfolioTransactionsListTranslationsFr, portfolioTransactionsListTranslationsIt, portfolioTransactionsListTranslationsNl } from '../portfolio-transactions-list/index.js';
import { portfolioTransactionAddTranslationsDe, portfolioTransactionAddTranslationsEn, portfolioTransactionAddTranslationsEs, portfolioTransactionAddTranslationsFr, portfolioTransactionAddTranslationsIt, portfolioTransactionAddTranslationsNl } from '../portfolio-transaction-add/index.js';
import { portfolioTransactionEditTranslationsDe, portfolioTransactionEditTranslationsEn, portfolioTransactionEditTranslationsEs, portfolioTransactionEditTranslationsFr, portfolioTransactionEditTranslationsIt, portfolioTransactionEditTranslationsNl } from '../portfolio-transaction-edit/index.js';
import { portfolioTransactionDeleteTranslationsDe, portfolioTransactionDeleteTranslationsEn, portfolioTransactionDeleteTranslationsEs, portfolioTransactionDeleteTranslationsFr, portfolioTransactionDeleteTranslationsIt, portfolioTransactionDeleteTranslationsNl } from '../portfolio-transaction-delete/index.js';
import { portfolioEvaluationChartTranslationsDe, portfolioEvaluationChartTranslationsEn, portfolioEvaluationChartTranslationsEs, portfolioEvaluationChartTranslationsFr, portfolioEvaluationChartTranslationsIt, portfolioEvaluationChartTranslationsNl } from '../portfolio-evaluation-chart/index.js';
import { portfolioBreakdownTranslationsDe, portfolioBreakdownTranslationsEn, portfolioBreakdownTranslationsEs, portfolioBreakdownTranslationsFr, portfolioBreakdownTranslationsIt, portfolioBreakdownTranslationsNl } from '../portfolio-breakdown/index.js';
import { portfolioPositionsPerformanceTranslationsDe, portfolioPositionsPerformanceTranslationsEn, portfolioPositionsPerformanceTranslationsEs, portfolioPositionsPerformanceTranslationsFr, portfolioPositionsPerformanceTranslationsIt, portfolioPositionsPerformanceTranslationsNl } from '../portfolio-positions-performance/index.js';
import { portfolioPositionsWeightTranslationsDe, portfolioPositionsWeightTranslationsEn, portfolioPositionsWeightTranslationsEs, portfolioPositionsWeightTranslationsFr, portfolioPositionsWeightTranslationsIt, portfolioPositionsWeightTranslationsNl } from '../portfolio-positions-weight/index.js';
import { portfolioListTranslationsDe, portfolioListTranslationsEn, portfolioListTranslationsEs, portfolioListTranslationsFr, portfolioListTranslationsIt, portfolioListTranslationsNl } from '../portfolio-list/index.js';
import { portfolioSelectorTranslationsDe, portfolioSelectorTranslationsEn, portfolioSelectorTranslationsEs, portfolioSelectorTranslationsFr, portfolioSelectorTranslationsIt, portfolioSelectorTranslationsNl } from '../portfolio-selector/index.js';
import { searchSuggesterTranslationsDe, searchSuggesterTranslationsEn, searchSuggesterTranslationsEs, searchSuggesterTranslationsFr, searchSuggesterTranslationsIt, searchSuggesterTranslationsNl } from '../search-suggester/index.js';
import { newsListTranslationsDe, newsListTranslationsEn, newsListTranslationsEs, newsListTranslationsFr, newsListTranslationsIt, newsListTranslationsNl } from '../news-list/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';

const portfolioTranslationsDe = {
  ...de,
  ...portfolioHeaderTranslationsDe,
  ...portfolioCreateTranslationsDe,
  ...portfolioDeleteTranslationsDe,
  ...portfolioEditTranslationsDe,
  ...portfolioPositionsListTranslationsDe,
  ...portfolioTransactionsListTranslationsDe,
  ...portfolioTransactionAddTranslationsDe,
  ...portfolioTransactionEditTranslationsDe,
  ...portfolioTransactionDeleteTranslationsDe,
  ...searchSuggesterTranslationsDe,
  ...newsListTranslationsDe,
  ...portfolioEvaluationChartTranslationsDe,
  ...portfolioBreakdownTranslationsDe,
  ...portfolioPositionsPerformanceTranslationsDe,
  ...portfolioPositionsWeightTranslationsDe,
  ...portfolioListTranslationsDe,
  ...portfolioSelectorTranslationsDe,
  ...localizationSupportTranslationsDe
};
const portfolioTranslationsEn = {
  ...en,
  ...portfolioHeaderTranslationsEn,
  ...portfolioCreateTranslationsEn,
  ...portfolioDeleteTranslationsEn,
  ...portfolioEditTranslationsEn,
  ...portfolioPositionsListTranslationsEn,
  ...portfolioTransactionsListTranslationsEn,
  ...portfolioTransactionAddTranslationsEn,
  ...portfolioTransactionEditTranslationsEn,
  ...portfolioTransactionDeleteTranslationsEn,
  ...searchSuggesterTranslationsEn,
  ...newsListTranslationsEn,
  ...portfolioEvaluationChartTranslationsEn,
  ...portfolioBreakdownTranslationsEn,
  ...portfolioPositionsPerformanceTranslationsEn,
  ...portfolioPositionsWeightTranslationsEn,
  ...portfolioListTranslationsEn,
  ...portfolioSelectorTranslationsEn,
  ...localizationSupportTranslationsEn
};
const portfolioTranslationsEs = {
  ...es,
  ...portfolioHeaderTranslationsEs,
  ...portfolioCreateTranslationsEs,
  ...portfolioDeleteTranslationsEs,
  ...portfolioEditTranslationsEs,
  ...portfolioPositionsListTranslationsEs,
  ...portfolioTransactionsListTranslationsEs,
  ...portfolioTransactionAddTranslationsEs,
  ...portfolioTransactionEditTranslationsEs,
  ...portfolioTransactionDeleteTranslationsEs,
  ...searchSuggesterTranslationsEs,
  ...newsListTranslationsEs,
  ...portfolioEvaluationChartTranslationsEs,
  ...portfolioBreakdownTranslationsEs,
  ...portfolioPositionsPerformanceTranslationsEs,
  ...portfolioPositionsWeightTranslationsEs,
  ...portfolioListTranslationsEs,
  ...portfolioSelectorTranslationsEs,
  ...localizationSupportTranslationsEs
};
const portfolioTranslationsFr = {
  ...fr,
  ...portfolioHeaderTranslationsFr,
  ...portfolioCreateTranslationsFr,
  ...portfolioDeleteTranslationsFr,
  ...portfolioEditTranslationsFr,
  ...portfolioPositionsListTranslationsFr,
  ...portfolioTransactionsListTranslationsFr,
  ...portfolioTransactionAddTranslationsFr,
  ...portfolioTransactionEditTranslationsFr,
  ...portfolioTransactionDeleteTranslationsFr,
  ...searchSuggesterTranslationsFr,
  ...newsListTranslationsFr,
  ...portfolioEvaluationChartTranslationsFr,
  ...portfolioBreakdownTranslationsFr,
  ...portfolioPositionsPerformanceTranslationsFr,
  ...portfolioPositionsWeightTranslationsFr,
  ...portfolioListTranslationsFr,
  ...portfolioSelectorTranslationsFr,
  ...localizationSupportTranslationsFr
};
const portfolioTranslationsIt = {
  ...it,
  ...portfolioHeaderTranslationsIt,
  ...portfolioCreateTranslationsIt,
  ...portfolioDeleteTranslationsIt,
  ...portfolioEditTranslationsIt,
  ...portfolioPositionsListTranslationsIt,
  ...portfolioTransactionsListTranslationsIt,
  ...portfolioTransactionAddTranslationsIt,
  ...portfolioTransactionEditTranslationsIt,
  ...portfolioTransactionDeleteTranslationsIt,
  ...searchSuggesterTranslationsIt,
  ...newsListTranslationsIt,
  ...portfolioEvaluationChartTranslationsIt,
  ...portfolioBreakdownTranslationsIt,
  ...portfolioPositionsPerformanceTranslationsIt,
  ...portfolioPositionsWeightTranslationsIt,
  ...portfolioListTranslationsIt,
  ...portfolioSelectorTranslationsIt,
  ...localizationSupportTranslationsIt
};
const portfolioTranslationsNl = {
  ...nl,
  ...portfolioHeaderTranslationsNl,
  ...portfolioCreateTranslationsNl,
  ...portfolioDeleteTranslationsNl,
  ...portfolioEditTranslationsNl,
  ...portfolioPositionsListTranslationsNl,
  ...portfolioTransactionsListTranslationsNl,
  ...portfolioTransactionAddTranslationsNl,
  ...portfolioTransactionEditTranslationsNl,
  ...portfolioTransactionDeleteTranslationsNl,
  ...searchSuggesterTranslationsNl,
  ...newsListTranslationsNl,
  ...portfolioEvaluationChartTranslationsNl,
  ...portfolioBreakdownTranslationsNl,
  ...portfolioPositionsPerformanceTranslationsNl,
  ...portfolioPositionsWeightTranslationsNl,
  ...portfolioListTranslationsNl,
  ...portfolioSelectorTranslationsNl,
  ...localizationSupportTranslationsNl
};
const portfolioTranslationsBundle = {
  de: portfolioTranslationsDe,
  en: portfolioTranslationsEn,
  es: portfolioTranslationsEs,
  fr: portfolioTranslationsFr,
  it: portfolioTranslationsIt,
  nl: portfolioTranslationsNl
};

export { portfolioTranslationsBundle, portfolioTranslationsDe, portfolioTranslationsEn, portfolioTranslationsEs, portfolioTranslationsFr, portfolioTranslationsIt, portfolioTranslationsNl };
